import { ReactNode } from 'react'
import { Id, toast, ToastOptions } from 'react-toastify'

import { TOAST_OPTIONS } from './common'
import { ToastMessage, ToastMessageProps } from './toast-message'

export const triggerToast = (
  type: ToastMessageProps['type'],
  message: ReactNode,
  options: ToastOptions = TOAST_OPTIONS
) => {
  toast(<ToastMessage type={type}>{message}</ToastMessage>, options)
}

export type NotificationToastOptions = {
  title: string
  message: string
  onClick?: () => void
}
export const triggerToastNotify = ({
  title,
  message,
  onClick,
}: NotificationToastOptions) => {
  toast(
    <ToastMessage
      type="notification"
      title={title}
      message={message}
      onClick={onClick}
    />,
    {
      ...TOAST_OPTIONS,
      autoClose: 8000,
    }
  )
}

export const showLoadingToast = (message: ReactNode): Id => {
  const loadingToastId = toast(
    <ToastMessage type="loading">{message}</ToastMessage>,
    {
      ...TOAST_OPTIONS,
      autoClose: 180000, // 3 minutes
      isLoading: true,
      position: 'top-right',
    }
  )
  return loadingToastId
}

export const closeToast = (toastId: Id | null) => {
  if (!toastId) return
  toast.dismiss(toastId)
}
